import { render, staticRenderFns } from "./allApprove.vue?vue&type=template&id=9d295154&scoped=true&"
import script from "./allApprove.vue?vue&type=script&lang=js&"
export * from "./allApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d295154",
  null
  
)

export default component.exports